import React, { useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import {
  Ballot,
  Close,
  ContentPaste,
  Euro,
  History,
  ListAlt,
  ManageAccounts,
  QuestionAnswer,
  Search,
  Diamond,
  HowToReg,
  ContactEmergency,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { IconButton } from "@mui/material";

var token: string | null = "";

function SideBar({ decodedToken, setOpenSideBar }) {
  const navigate = useNavigate();
  const user = localStorage.getItem("user");
  token = localStorage.getItem("token");
  const requestType = localStorage.getItem("requestType");
  const clientSideBarOptions = [
    "جدول ارز ها",
    "گزارش سفارشات",
    "نظرسنجی",
    "نمایش فرم ها",
    "تاریخچه درخواست ها",
    "اطلاعات تکمیلی مشتری",
    "سرویس های من",
    "باشگاه مشتریان",
  ];
  const expertSideBarOptions = [
    "جدول ارز ها",
    "جستجوی سفارش",
    "تاریخچه درخواست ها",
    "سرویس های کاربران",
  ];
  const adminSideBarOptions = [
    "جدول ارز ها",
    "جستجوی سفارش",
    "لیست کاربران",
    "نظرسنجی",
    "ایجاد فرم نظرسنجی",
    "تاریخچه درخواست ها",
    "تعریف سطح و خدمات",
    "سرویس های کاربران",
  ];
  const enterWithNationalCodeSideBarOption = [
    "جدول ارز ها",
    "تاریخچه درخواست ها",
    "اطلاعات تکمیلی مشتری",
  ];
  const isDesktop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isTablet = useMediaQuery({
    query: "(max-width: 768px)",
  });
  const isMobile = useMediaQuery({
    query: "(max-width: 400px)",
  });
  const showIcon = (value) => {
    switch (value) {
      case "جدول ارز ها":
        return <Euro />;
      case "گزارش سفارشات":
        return <ContentPaste />;
      case "نظرسنجی":
        return <QuestionAnswer />;
      case "جستجوی سفارش":
        return <Search />;
      case "لیست کاربران":
        return <ListAlt />;
      case "ایجاد فرم نظرسنجی":
        return <Ballot />;
      case "نمایش فرم ها":
        return <ListAlt />;
      case "تاریخچه درخواست ها":
        return <History />;
      case "اطلاعات تکمیلی مشتری":
        return <ManageAccounts />;
      case "تعریف سطح و خدمات":
        return <Diamond />;
      case "باشگاه مشتریان":
        return <Diamond />;
      case "سرویس های من":
        return <HowToReg />;
      case "سرویس های کاربران":
        return <ContactEmergency />;
      default:
        break;
    }
  };
  const handleRouteToPageExpert = (value) => {
    switch (value) {
      case "جدول ارز ها":
        navigate("/CurrencyRates");
        setOpenSideBar(false);
        break;
      case "گزارش سفارشات":
        navigate(`/RequestDetails/${user}`);
        setOpenSideBar(false);
        break;
      case "نظرسنجی":
        navigate("/listOfQuestions");
        setOpenSideBar(false);
        break;
      case "جستجوی سفارش":
        navigate("/searchRequest");
        setOpenSideBar(false);
        break;
      case "لیست کاربران":
        navigate("/requestList");
        setOpenSideBar(false);
        break;
      case "ایجاد فرم نظرسنجی":
        navigate("/expertAddPoll");
        setOpenSideBar(false);
        break;
      case "تاریخچه درخواست ها":
        navigate("/adminRequestHistory");
        setOpenSideBar(false);
        break;
      case "تعریف سطح و خدمات":
        navigate("/expertServices");
        setOpenSideBar(false);
        break;
      case "سرویس های کاربران":
        navigate("/adminCheckServices");
        setOpenSideBar(false);
        break;
      default:
        setOpenSideBar(false);
        break;
    }
  };

  const handleRouteToPageClient = (value) => {
    switch (value) {
      case "جدول ارز ها":
        navigate("/CurrencyRates");
        setOpenSideBar(false);
        break;
      case "گزارش سفارشات":
        navigate(`/RequestDetails/${user}`);
        setOpenSideBar(false);
        break;
      case "نظرسنجی":
        navigate("/listOfQuestions");
        setOpenSideBar(false);
        break;
      case "نمایش فرم ها":
        if (requestType === "Nima") {
          navigate("/nimaForms");
        } else {
          navigate("/sanaForms");
        }
        setOpenSideBar(false);
        break;
      case "تاریخچه درخواست ها":
        navigate("/adminRequestHistory");
        setOpenSideBar(false);
        break;
      case "اطلاعات تکمیلی مشتری":
        navigate("/customerDetails");
        setOpenSideBar(false);
        break;
      case "باشگاه مشتریان":
        navigate("/costumerServicesList");
        setOpenSideBar(false);
        break;
      case "سرویس های من":
        navigate("/costumerAssignedServices");
        setOpenSideBar(false);
        break;
      default:
        setOpenSideBar(false);
        break;
    }
  };
  return (
    <div>
      <List>
        {decodedToken.role === "Admin"
          ? adminSideBarOptions.map((text, index) => (
              <ListItem
                key={index}
                disablePadding
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <ListItemButton
                  onClick={() => handleRouteToPageExpert(text)}
                  sx={{ display: "flex", justifyContent: "space-between" }}
                >
                  <ListItemText primary={text} />
                  <ListItemIcon sx={{ left: "0px" }}>
                    {showIcon(text)}
                  </ListItemIcon>
                </ListItemButton>
              </ListItem>
            ))
          : decodedToken.role === "Expert"
          ? expertSideBarOptions.map((text, index) => (
              <ListItem
                key={index}
                disablePadding
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <ListItemButton
                  onClick={() => handleRouteToPageExpert(text)}
                  sx={{ display: "flex", justifyContent: "space-between" }}
                >
                  <ListItemText primary={text} />
                  <ListItemIcon sx={{ left: "0px" }}>
                    {showIcon(text)}
                  </ListItemIcon>
                </ListItemButton>
              </ListItem>
            ))
          : !decodedToken.Type
          ? enterWithNationalCodeSideBarOption.map((text, index) => (
              <ListItem
                key={index}
                disablePadding
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <ListItemButton
                  onClick={() => handleRouteToPageClient(text)}
                  sx={{ display: "flex", justifyContent: "space-between" }}
                >
                  <ListItemText primary={text} />
                  <ListItemIcon sx={{ left: "0px" }}>
                    {showIcon(text)}
                  </ListItemIcon>
                </ListItemButton>
              </ListItem>
            ))
          : clientSideBarOptions.map((text, index) => (
              <ListItem
                key={index}
                disablePadding
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <ListItemButton
                  onClick={() => handleRouteToPageClient(text)}
                  sx={{ display: "flex", justifyContent: "space-between" }}
                >
                  <ListItemText primary={text} />
                  <ListItemIcon>{showIcon(text)}</ListItemIcon>
                </ListItemButton>
              </ListItem>
            ))}
        {isDesktop ? null : (
          <ListItem sx={{ display: "flex", justifyContent: "center" }}>
            <ListItemIcon>
              <IconButton
                aria-label=""
                sx={{ backgroundColor: "#ddd" }}
                onClick={() => setOpenSideBar(false)}
              >
                <Close />
              </IconButton>
            </ListItemIcon>
          </ListItem>
        )}
      </List>
    </div>
  );
}

export default SideBar;
